import React from "react";

export default () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="Vector"
                d="M11.342 0.59375L9.82947 2.10625L13.892 6.16875L15.4045 4.65625C16.1857 3.875 16.1857 2.60937 15.4045 1.82812L14.1732 0.59375C13.392 -0.1875 12.1263 -0.1875 11.3451 0.59375H11.342ZM9.12322 2.8125L1.83885 10.1C1.51385 10.425 1.27635 10.8281 1.1451 11.2687L0.0388459 15.0281C-0.0392791 15.2937 0.0325959 15.5781 0.226346 15.7719C0.420096 15.9656 0.704471 16.0375 0.966971 15.9625L4.72635 14.8562C5.16697 14.725 5.5701 14.4875 5.8951 14.1625L13.1857 6.875L9.12322 2.8125Z"
                fill="#333739"
            />
        </svg>
    );
};
